import { createStore } from '@stencil/store';
import { PartnerDisclaimerData } from '../components';

// Create the store
const { state } = createStore<{ disclaimerData: PartnerDisclaimerData }>({
  disclaimerData: {}
});

// Export the state
export const disclaimerStore = state;
